import request from '@/utils/request'

// post /api/v1/admin/risk_control/blacklist/add 新增黑名单
export function addBlacklist(data) {
  return request({
    url: '/api/v1/admin/risk_control/blacklist/add',
    method: 'post',
    data,
    mock: false,
  })
}

// post /api/v1/admin/risk_control/blacklist/create 创建黑名单
export function createBlacklist(data) {
  return request({
    url: '/api/v1/admin/blacklist/create',
    method: 'post',
    data,
    mock: false,
  })
}
// post /api/v1/admin/risk_control/blacklist/delete 删除黑名单
export function deleteBlacklist(data) {
  return request({
    url: '/api/v1/admin/blacklist/delete',
    method: 'post',
    data,
    mock: false,
  })
}

// post /api/v1/admin/risk_control/blacklist/list 黑名单列表
export function getBlacklistList(data) {
  return request({
    url: '/api/v1/admin/blacklist/list',
    method: 'post',
    data,
    mock: false,
  })
}

// post /api/v1/admin/risk_control/blacklist/update 更新黑名单
export function updateBlacklist(data) {
  return request({
    url: '/api/v1/admin/blacklist/update',
    method: 'post',
    data,
    mock: false,
  })
}

// post /api/v1/admin/risk_control/login_log/list 登录日志列表
export function getLoginLogList(data) {
  return request({
    url: '/api/v1/admin/risk_control/login_log/list',
    method: 'post',
    data,
    mock: false,
  })
}
///api/v1/admin/log/login/list
export function getLoginLog(data) {
  return request({
    url: '/api/v1/admin/log/login/list',
    method: 'post',
    data,
    mock: false,
  })
}

// post /api/v1/admin/risk_control/login_log/list/device 登录日志设备列表
export function getLoginLogDeviceList(data) {
  return request({
    url: '/api/v1/admin/risk_control/login_log/list/device',
    method: 'post',
    data,
    mock: false,
  })
}

// post /api/v1/admin/risk_control/login_log/list/ip 登录日志IP列表
export function getLoginLogIpList(data) {
  return request({
    url: '/api/v1/admin/risk_control/login_log/list/ip',
    method: 'post',
    data,
    mock: false,
  })
}
// /get_normal_agent_player_by_device_ip
export function getAgentPlayerByDeviceIp(data) {
  return request({
    url: '/api/v1/admin/agent/get_normal_agent_player_by_device_ip',
    method: 'post',
    data,
    mock: false,
  })
}

export const loginLogApi = {
  getAgentPlayerByDeviceIp,
  createBlacklist,
  addBlacklist,
  deleteBlacklist,
  getBlacklistList,
  updateBlacklist,
  getLoginLogList,
  getLoginLogDeviceList,
  getLoginLogIpList,
}
